import React, { useEffect, useState } from "react";
import axios from "axios";

const API = "/api";

function Students() {
  const [students, setStudents] = useState([]);
  const [name, setName] = useState("");
  const [course, setCourse] = useState("");

  const fetchStudents = async () => {
    const res = await axios.get(`${API}/students`);
    setStudents(res.data);
  };

  useEffect(() => {
    fetchStudents();
  }, []);

  const addStudent = async () => {
    if (!name || !course) {
      alert("Fill all fields");
      return;
    }

    await axios.post(`${API}/students`, {
      name,
      course,
    });

    setName("");
    setCourse("");
    fetchStudents();
  };

  const deleteStudent = async (id) => {
    await axios.delete(`${API}/students/${id}`);
    fetchStudents();
  };

  const editStudent = (student) => {
    const newName = prompt("Enter new name", student.name);
    const newCourse = prompt("Enter new course", student.course);

    if (newName && newCourse) {
      axios
        .put(`${API}/students/${student.id}`, {
          name: newName,
          course: newCourse,
        })
        .then(() => {
          fetchStudents();
        });
    }
  };

  return (
    <div className="p-4">
      <h2 className="mb-4">Student Management</h2>

      {/* ADD FORM */}
      <div className="card p-3 mb-4 shadow">
        <div className="row g-2">
          <div className="col-md-4">
            <input
              className="form-control"
              placeholder="Enter Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="col-md-4">
            <input
              className="form-control"
              placeholder="Enter Course"
              value={course}
              onChange={(e) => setCourse(e.target.value)}
            />
          </div>

          <div className="col-md-4">
            <button className="btn btn-primary w-100" onClick={addStudent}>
              Add Student
            </button>
          </div>
        </div>
      </div>

      {/* TABLE */}
      <table className="table table-bordered shadow">
        <thead className="table-dark">
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Course</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {students.map((s) => (
            <tr key={s.id}>
              <td>{s.id}</td>
              <td>{s.name}</td>
              <td>{s.course}</td>
              <td>
                <button
                  className="btn btn-warning btn-sm me-2"
                  onClick={() => editStudent(s)}
                >
                  Edit
                </button>

                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => deleteStudent(s.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Students;